import { isSupportedDataType, isValidCurrencyPairSymbol, isValidDateInput } from '../helpers/args-validators';
import { excelSerialToJsDate, javascriptDateToMMDDYYYY, javascriptDateToYYYYMMDD } from '../helpers/date-helpers';
import { FunctionCallCache } from '../helpers/functionCallCache';
import { FunctionLocationTracker } from '../helpers/functionLocationTracker';
import { KeyBuilder } from '../helpers/keyBuilder';
const SUPPORTED_DATETYPES = ['Daily_Closing_Value'];
function validateArgs(symbol, dataType, date) {
    if (!isValidCurrencyPairSymbol(symbol)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid symbol (expected format: EXCHANGE:TICKER)');
    }
    if (!isSupportedDataType(SUPPORTED_DATETYPES, dataType)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid data type');
    }
    if (!isValidDateInput(String(date))) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid date');
    }
    return true;
}
let delegate = () => {
    throw new CustomFunctions.Error(CustomFunctions.ErrorCode.notAvailable, 'Initializing… press F9 to recalc.');
};
export function setCurrencyDelegate(fn) {
    delegate = fn;
}
export function currencyWrapper(symbol, dataType, date, invocation) {
    return delegate(symbol, dataType, date, invocation);
}
export function currencyImpl(symbol, dataType, date, invocation) {
    validateArgs(symbol, dataType, date);
    const javascriptDate = String(date).includes('/') ? new Date(date) : excelSerialToJsDate(Number(date));
    const queryDate = javascriptDateToYYYYMMDD(javascriptDate);
    const cache = FunctionCallCache.getInstance();
    const tracker = FunctionLocationTracker.getInstance();
    const args = { symbol, dataType, date: queryDate };
    const key = KeyBuilder.build('currency', args);
    cache.registerByKey(key, { functionName: 'currency', params: args });
    if (invocation?.address) {
        // the key contains the function name and args
        tracker.registerCell(key, invocation.address, `=ALPHA.CURRENCY("${symbol}", "${dataType}", "${javascriptDateToMMDDYYYY(javascriptDate)}")`);
        cache.setAutoRefresh(key);
    }
    const result = cache.getValueForExcelByKey(key);
    return result;
}
//# sourceMappingURL=currency.js.map